import React = require('react')

export const useBreakpointMatches = (direction: 'up' | 'down', targetBreakpoint: number): boolean => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize, { passive: true })
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return direction === 'up' ? windowWidth >= targetBreakpoint : windowWidth < targetBreakpoint
}
